import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const empGovtTaxSlice = createSlice({
  name: "govtTax",

  initialState: { empGovtTax: [] },
  reducers: {
    setEmployeeAssignGovtTax: (state: any, action: PayloadAction<any>) => {
      console.log("ACTION @ EMP GOVT TAX--", action);
      state.empGovtTax = action.payload;
    },

    resetEmployeeAssignGovtTax: (state: any) => {
      state = [];
    },
  },
});

export const { setEmployeeAssignGovtTax, resetEmployeeAssignGovtTax } =
  empGovtTaxSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default empGovtTaxSlice.reducer;
